import { IClubPeriodVm } from "../models/response/club/IClubPeriodVm";
import { IClubResgistrationVm } from "../models/response/club/IClubResgistrationVm";
import { apiClient } from "./apiClient";

export const clubApi = {
    periodSaveChange: (payload: IClubPeriodVm) => apiClient.post('club-registration-period', payload),
    periodSelect: () => apiClient.get("club-registration-period"),
    periodSelectDetail: (id: number) => apiClient.get("club-registration-period/" + id.toString()),
    periodDelete: (id: number) => apiClient.delete("club-registration-period/" + id.toString()),
    sendNotify: (id: number) => apiClient.post("club-registration-period/" + id.toString() + '/notify'),

    clubSaveChange: (payload: IClubResgistrationVm) => apiClient.post('club-registration-club', payload),
    clubSelect: () => apiClient.get("club-registration-club"),
    clubSelectDetail: (id: number) => apiClient.get("club-registration-club/" + id.toString()),
    clubDelete: (id: number) => apiClient.delete("club-registration-club/" + id.toString()),
    clubRegisterResult: (id: number) => apiClient.get("club-registration-club/" + id.toString() + "/history"),
}